import _ from 'lodash';

const SHOW_MESSAGE = 'SHOW_MESSAGE';
const DISMISS_MESSAGE = 'DISMISS_MESSAGE';

const createDefault = () => ({
  message: '',
  messageIcon: '',
  target: null,
  visible: false,
  useModal: false,
});

function reducer(state, action) {
  const { type, payload } = action;
  switch (type) {
    case SHOW_MESSAGE:
      if (
        payload.event &&
        payload.event.currentTarget &&
        payload.event.currentTarget === state.target
      ) {
        return createDefault();
      }
      return {
        message: payload.message,
        messageIcon: payload.messageIcon,
        useModal: payload.useModal,
        target: _.get(payload, 'event.currentTarget', null),
        visible: true,
      };
    case DISMISS_MESSAGE:
      return createDefault();
    default:
      return state || createDefault();
  }
}
export { SHOW_MESSAGE, DISMISS_MESSAGE, createDefault, reducer };
